import { Link } from "react-router-dom";
import { ButtonBase } from "@mui/material";
import { LogoSvg } from "./LogoSvg";
import { config } from "Common/Constants";

export const Logo = ({ to }: { to: string | undefined }) => (
  <ButtonBase disableRipple component={Link} to={!to ? config.defaultPath : to}>
    <LogoSvg />
  </ButtonBase>
);
